import { composites } from '../../../../common/constants/access';
import { companyPropertiesConstants } from '../../../constants/appConstants';
import { companyPropertiesQuery } from '../../../queries/companyQuery';
import { selectedTeamIdQuery, teamQuery, teamsQuery } from '../../../queries/teamQuery';
import { getVerifyUserAccessQuery, userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';
export const teamsCardsLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');

	const verifyUserAccessQuery = getVerifyUserAccessQuery((composites as any).WRITE_CARD_SOURCES);

	const teamId = await queryClient.ensureQueryData(teamIdQuery);

	const userData = await queryClient.ensureQueryData(userQuery);

	const teams = await queryClient.ensureQueryData(teamsQuery());

	const team = await queryClient.ensureQueryData(teamQuery({ teamId: teamId?.[0] || '' }));

	const hasAccess = await queryClient.ensureQueryData({
		queryKey: verifyUserAccessQuery.queryKey,
		queryFn: verifyUserAccessQuery.queryFn,
	});

	const companyProperties = await queryClient.ensureQueryData(
		companyPropertiesQuery(userData.companyAccountId, companyPropertiesConstants),
	);

	return {
		teamId,
		userData,
		teams,
		team,
		hasAccess,
		companyProperties,
	};
};
